module.exports = __webpack_public_path__ + "static/media/Building.8b0c6e4f.svg";